const constants = {
  COMMUNITY_DEFAULT_COUNTRY_CODE: "COMMUNITY_DEFAULT_COUNTRY_CODE",
  COMMUNITY_DEFAULT_LANGUAGE: "COMMUNITY_DEFAULT_LANGUAGE",
  COMMUNITY_DEFAULT_FONT_LINK: "COMMUNITY_DEFAULT_FONT_LINK",
  COMMUNITY_DEFAULT_FONT_NAME: "COMMUNITY_DEFAULT_FONT_NAME",
};

export default constants;
